export { default } from './PageWithGraphic';
